import { getEnvironmentVariable } from 'utils/env'

import { SupportedChainId } from './chains'

const INFURA_KEY = process.env.REACT_APP_INFURA_KEY
if (typeof INFURA_KEY === 'undefined') {
  throw new Error(`REACT_APP_INFURA_KEY must be a defined environment variable`)
}

const HYDRACHAIN_MAINNET_RPC = getEnvironmentVariable('REACT_APP_HYDRACHAIN_MAINNET_RPC')
const HYDRACHAIN_TESTNET_RPC = getEnvironmentVariable('REACT_APP_HYDRACHAIN_TESTNET_RPC')
const HYDRACHAIN_DEVNET_RPC = getEnvironmentVariable('REACT_APP_HYDRACHAIN_DEVNET_RPC')

/**
 * Fallback JSON-RPC endpoints.
 * These are used if the integrator does not provide an endpoint, or if the endpoint does not work.
 *
 * MetaMask allows switching to any URL, but displays a warning if it is not on the "Safe" list:
 * https://github.com/MetaMask/metamask-mobile/blob/bdb7f37c90e4fc923881a07fca38d4e77c73a579/app/core/RPCMethods/wallet_addEthereumChain.js#L228-L235
 * https://chainid.network/chains.json
 *
 * These "Safe" URLs are listed first, followed by other fallback URLs, which are taken from chainlist.org.
 */
export const FALLBACK_URLS: { [key in SupportedChainId]: string[] } = {
  // SAMVI Update: We need fallback URLs for the RPCs of Hydra Mainnet

  [SupportedChainId.HYDRA]: [
    // "Safe" URLs
    HYDRACHAIN_MAINNET_RPC,
    // "Fallback" URLs
    // 'https://rpc.ankr.com/eth',
    // 'https://eth-mainnet.public.blastapi.io',
  ],
  [SupportedChainId.TESTNET]: [
    // "Safe" URLs
    HYDRACHAIN_TESTNET_RPC,
  ],
  [SupportedChainId.DEVNET]: [
    // "Safe" URLs
    HYDRACHAIN_DEVNET_RPC,
  ],
}

/**
 * Known JSON-RPC endpoints.
 * These are the URLs used by the interface when there is not another available source of chain data.
 */
export const RPC_URLS: { [key in SupportedChainId]: string[] } = {
  [SupportedChainId.HYDRA]: [HYDRACHAIN_MAINNET_RPC, ...FALLBACK_URLS[SupportedChainId.HYDRA]],
  [SupportedChainId.TESTNET]: [HYDRACHAIN_TESTNET_RPC, ...FALLBACK_URLS[SupportedChainId.TESTNET]],
  [SupportedChainId.DEVNET]: [HYDRACHAIN_DEVNET_RPC, ...FALLBACK_URLS[SupportedChainId.DEVNET]],
}
